<br/>
<br/>
<br/>
<form #loginForm="ngForm">
    <mat-card class="pre-card">
        <mat-card-header>
            <mat-card-title>        
                <mat-toolbar color="primary" class="pre-title">
                    <img src="assets/img/udg_blanc_transparent_small.png" class="pre-titol-logo">
                    <span i18n>Preinscripció</span>
                    <span class="pre-spacer"></span>
                    <div class="button-row">
                        <a mat-button *ngFor="let l of dataService.languages_app" href="../{{localize(l.name)}}" target="_self" style="min-width: 10px">{{l.name | uppercase}}</a>
                    </div>              
                </mat-toolbar>                
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="pre-form">
            <p *ngIf="!initialized" i18n>Carregant...</p>
            <mat-grid-list *ngIf="initialized" cols="2" rows="3" rowHeight="100px">
            <mat-grid-tile colspan="2">
                <mat-form-field class="pre-field">
                    <input matInput placeholder="Pla" disabled [value]="login.oferta?.name" *ngIf="!escollirOferta" name="ofertaFixada">
                    <mat-select placeholder="Màster al qual us voleu preinscriure" *ngIf="escollirOferta" [(ngModel)]="login.oferta" name="ofertaSeleccionada" required  i18n-placeholder>
                        <mat-option *ngFor="let o of ofertes" [value]="o">
                        {{ o.name }}
                        </mat-option>
                    </mat-select>  
                </mat-form-field>                  
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field class="pre-field">
                    <input type="text" matInput placeholder="Document identificatiu" [(ngModel)]="login.documentIdentificatiu" name="documentIdentificatiu" 
                        pattern="[A-Za-z0-9]+" required  i18n-placeholder>
                        <mat-error i18n="@@ErrorDocumentIdentificatiu">
                            El document identificatiu no és vàlid. Només pot contenir números i lletres. Cal ignorar els espais, guions, barres i altres caràcters estranys.
                      </mat-error>                        
                </mat-form-field>  
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field class="pre-field">
                    <input type="text" matInput placeholder="Data de naixement" [(ngModel)]="login.dataNaixement" name="dataNaixement" 
                        pattern="(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}" required i18n-placeholder="@@DataNaixementLogin">
                </mat-form-field>                        
            </mat-grid-tile>
            <mat-grid-tile colspan="2">
                <mat-checkbox class="pre-controls-left" required name="acceptacioLopd" [(ngModel)]="login.acceptaLopd"
                    matTooltip="Les dades personals recollides en el procés de preinscripció seran incorporades al fitxer de gestió acadèmica de la Universitat de Girona, creat per a l’organització de la docència i per a l’exercici de la resta de funcions pròpies del servei públic de l’educació superior, regulades a la Llei orgànica d’universitats. Podreu exercir els vostres drets d’accés, rectificació, oposició i cancel·lació adreçant-vos a la Secretaria General de la Universitat de Girona."
                    matTooltipPosition="below" i18n i18n-matTooltip>Accepto les condicions de protecció de dades <i class="material-icons">info_outline</i></mat-checkbox>         
            </mat-grid-tile>           
            </mat-grid-list>
        </mat-card-content>  
        <mat-card-actions align="end">
            <button mat-raised-button color="primary" (click)="inicia()" [disabled]="!loginForm.form.valid" i18n>INICIA</button>
        </mat-card-actions>  
    </mat-card>
</form>


// WEBPACK FOOTER //
// ./src/app/login/login.component.html